import type { CustomFlowbiteTheme } from 'flowbite-react';

export const tableTheme: CustomFlowbiteTheme['table'] = {
  root: {
    base: 'w-full text-left text-sm text-titan-night-500',
    shadow:
      'absolute bg-white hidden group-hover:block z-10 w-max rounded-lg border border-titan-night-200 shadow-md',
    wrapper: 'relative',
  },
  body: {
    base: 'group/body',
    cell: {
      base: 'group-first/body:group-first/row:first:rounded-tl-lg group-first/body:group-first/row:last:rounded-tr-lg group-last/body:group-last/row:first:rounded-bl-lg group-last/body:group-last/row:last:rounded-br-lg px-6 py-4',
    },
  },
  head: {
    base: 'group/head text-xs uppercase text-titan-night-700 bg-gray-100',
    cell: {
      base: 'group-first/head:first:rounded-tl-lg group-first/head:last:rounded-tr-lg bg-titan-gray-100 px-6 py-3',
    },
  },
  row: {
    base: 'group/row',
    hovered: 'hover:bg-titan-gray-100',
    striped: 'odd:bg-white even:bg-titan-gray-100',
  },
};
